import React from "react";

const STEPS = [
  { title: "Complete the Lab Health Score", body: "Free 27-question self-assessment across 10 compliance domains. Results in 15 minutes." },
  { title: "We identify your highest-risk gaps", body: "Domain-by-domain heat map. Top findings ranked by regulatory risk, each mapped to specific CLIA/CAP citations." },
  { title: "We build the workflows that fix them", body: "Governed AI-assisted drafting with mandatory human review, ALCOA+ audit trail, and documentation that holds up." },
];

export default function HowItWorks() {
  return (
    <section className="py-16 bg-muted/50 border-y border-border">
      <div className="max-w-6xl mx-auto px-6">
        <h2 className="text-2xl sm:text-3xl font-extrabold text-brand-navy text-center mb-10">How it works</h2>
        <div className="grid md:grid-cols-3 gap-8">
          {STEPS.map((s, i) => (
            <div key={s.title} className="text-center md:text-left">
              <div className="w-10 h-10 rounded-full bg-brand-teal text-white font-bold flex items-center justify-center mx-auto md:mx-0 mb-4">
                {i + 1}
              </div>
              <h3 className="text-lg font-bold text-brand-navy mb-2">{s.title}</h3>
              <p className="text-sm text-muted-foreground leading-relaxed">{s.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}